import Login from "./login/Login";
import ResetPassword from "./reset-password/ResetPassword";
import FashionbizLogo from "../../assets/FashionbizLogo";

interface Props {
  reset?: boolean;
}

const AuthPage = ({ reset }: Props) => {
  return (
    <div className="auth-page">
      <div className="main-content">
        <div className="logos-section">
          <FashionbizLogo className="auth-logo" />
        </div>
        <div className="form-wrapper">{reset ? <ResetPassword /> : <Login />}</div>
      </div>
    </div>
  );
};

export default AuthPage;
